import { render, staticRenderFns } from "./Add-Group.vue?vue&type=template&id=08329fe0"
import script from "./Add-Group.vue?vue&type=script&lang=js"
export * from "./Add-Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports